import { create } from "zustand";

export const useProductStore = create((set) => ({
  selectedProduct: null,
  selectedProjectGeneratedAssets: null,  // add this state

  setSelectedProduct: (product) => set({ selectedProduct: product }),
  setSelectedProjectGeneratedAssets: (assets) => set({ selectedProjectGeneratedAssets: assets }), // add this setter
}));
